import { _appVersion } from '../cnr/contexts/ServiceWorkerContext';

export const appVersionDiv = (app_metas, app_name) => {
  return <div style={{ padding: '1em', textAlign: 'center', fontSize: '.7rem', color: 'grey', display: 'flex', flexDirection: 'column', gap: '1em' }}>
    <div> {_appVersion}</div>
    <div>{app_metas?.auth?.appName}</div>
  </div>
}
